// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ForumPosts__list":"sz_a bhy_rc bhy_qx bhy_xr","ForumPosts__contest":"sz_b bhy_hq","ForumPosts__counselling":"sz_c"};